import { render, staticRenderFns } from "./editAndAdd.vue?vue&type=template&id=c619e898&"
import script from "./editAndAdd.vue?vue&type=script&lang=js&"
export * from "./editAndAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports